import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireEmployee?: boolean;
  fallbackPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireEmployee = false,
  fallbackPath = "/sign-in"
}) => {
  const { user, loading: supabaseLoading, isEmployee } = useAuth();

  // Return null while loading - GlobalLayout is already showing navbar/sidebar
  if (supabaseLoading) {
    return null;
  }

  // Check if user is authenticated via either system
  const isAuthenticated = user; // || isCorbadoAuthenticated;

  if (!isAuthenticated) {
    // Not logged in via either system, redirect to sign-in
    return <Navigate to={fallbackPath} replace />;
  }

  // If employee access is required, check employee status
  if (requireEmployee && !isEmployee) {
    // Authenticated but not an employee, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // User is properly authenticated, render children
  return <>{children}</>;
};

export default ProtectedRoute;